import React, { Component } from 'react';
import moment from 'moment';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import Usuario from '../../Utils/Usuario';
import Session from '../../Utils/Session';
import './Editions.scss';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import update from 'immutability-helper';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import DivPermission from '../../Components/Div-Permission/Div-Permission';
import Articles from '../../Components/Articles/Articles';
import qs from 'qs';
import Pagination from 'rc-pagination';
import ModalPdfsAdicionais from '../../Components/Modal-Pdfs-Adicionais/Modal-Pdfs-Adicionais';



class EditionDetails extends Component {

    constructor(props) {
        super(props);

        this.editarConteudo = this.editarConteudo.bind(this);
        this.defineNomePeriodico = this.defineNomePeriodico.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.novoArtigo = this.novoArtigo.bind(this);
        this.mudaStatusArtigo = this.mudaStatusArtigo.bind(this);
        this.mudaStatusEdicao = this.mudaStatusEdicao.bind(this);
        this.toggleStatusPublicacao = this.toggleStatusPublicacao.bind(this);
        this.onSelectFile = this.onSelectFile.bind(this);
        this.uploadArquivo = this.uploadArquivo.bind(this);
        this.removerArquivo = this.removerArquivo.bind(this);
        this.toggleRemoverArquivo = this.toggleRemoverArquivo.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.refreshTableArticles = this.refreshTableArticles.bind(this);
        this.handleSelectStatusAprovacao = this.handleSelectStatusAprovacao.bind(this);
        this.salvarStatusAprovacao = this.salvarStatusAprovacao.bind(this);
        this.carregaArtigos = this.carregaArtigos.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onSelectFileCoverPageEdition = this.onSelectFileCoverPageEdition.bind(this);
        this.uploadArquivoCapaEdicao = this.uploadArquivoCapaEdicao.bind(this);
        this.toggleRemoverArquivoCapaEdicao = this.toggleRemoverArquivoCapaEdicao.bind(this);
        this.removerArquivoCapaEdicao = this.removerArquivoCapaEdicao.bind(this);
        this.toggleModalPdfsAdcionais = this.toggleModalPdfsAdcionais.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            openModal: false,
            dtEdicao: null,
            numEdicao: this.props.match.params.numEdicao,
            isLoadingArtigos: false,
            isLoadingStatusEdicao: false,
            modalStatusPublicacao: false,
            metodoStatusPublicacao: "publicar",
            statusEdicao: "",
            exibeUpload: false,
            sucessoUpload: false,
            modalRemoverArquivo: false,
            hasError: false,
            errorMessage: '',
            limite: 20,
            pagina: 0,
            listaArtigos: [],
            isLoadingStatusAprovacao: false,
            msgSucessoStatusAprovacao: false,
            semEdicao: this.props.match.params.numEdicao === 'sem-edicao',
            capaEdicao: '',
            exibeUploadCapaEdicao: false,
            sucessoUploadCapaEdicao: false,
            modalRemoverArquivoCapaEdicao: false,
            isLoadingUploadCapaEdicao: false,
            arquivosAdicionais: [],
            modalPdfsAdicionais: false

        }

        this.opcoesStatusAprovacao = [
            { label: "Pendente", value: 1, periodicos: ["bs", "tc", "rd"] },
            { label: "Disponível para Redação", value: 2, periodicos: ["bs", "tc", "rd"] },
            { label: "Disponível para Diretoria", value: 3, periodicos: ["rd"] },
            { label: "Aprovado", value: 4, periodicos: ["bs", "tc", "rd"] }
        ]

    }

    componentDidMount() {
        this.carregaArtigos();
    }

    mudaStatusArtigo(_metodo, _idConteudo) {
        const _index = this.state.listaArtigos.findIndex(item => item.idConteudo === _idConteudo);

        this.setState({ listaArtigos: update(this.state.listaArtigos, { [_index]: { loading: { $set: true } } }) })

        axios.post(this.Configurations.apiBasePath + `/conteudo/artigos/${_idConteudo}/${_metodo}`)
            .then(response => { })
            .catch(this.handleError)
            .finally(() => {
                const rotaApi = this.state.semEdicao ? `/conteudo/edicoes/${this.props.match.params.periodico.toUpperCase()}/artigos-sem-edicao` : `/conteudo/edicoes/${this.props.match.params.periodico.toUpperCase()}/artigos/${this.state.numEdicao}`
                axios.get(this.Configurations.apiBasePath + rotaApi).then(response => {
                    this.setState({
                        listaArtigos: response.data.artigos,
                    });
                }).catch(this.handleError).finally(() => this.setState({ isLoadingArtigos: false }));
            })
    }

    mudaStatusEdicao() {
        this.setState({ isLoadingStatusEdicao: true })
        axios.post(this.Configurations.apiBasePath + `/conteudo/edicoes/${this.props.match.params.periodico}/${this.state.numEdicaoStatusPublicacao}/${this.state.metodoStatusPublicacao}`)
            .then(response => {
                this.carregaArtigos();
            })
            .catch(this.handleError)
            .finally(() => {
                this.toggleStatusPublicacao();
                this.setState({ isLoadingStatusEdicao: false }, () => this.toggleStatusPublicacao)
            });

    }

    confirmaStatusPublicacao(_numEdicao, _metodo) {
        this.toggleStatusPublicacao();
        this.setState({
            numEdicaoStatusPublicacao: _numEdicao,
            metodoStatusPublicacao: _metodo
        })
    }

    componentWillUnmount() {
        if (!window.location.href.includes(`conteudo/${this.props.match.params.periodico}`)) Session.clearInfosEdicoes();
    }

    componentWillMount() {
        let _permissoes;
        switch (this.props.match.params.periodico) {
            case "bs":
                _permissoes = [1, 4, 5, 14, 20];
                break;
            case "bj":
                _permissoes = [1, 4, 28, 14, 20];
                break;
            case "tc":
                _permissoes = [1, 4, 6, 14, 20];
                break;
            case "rd":
                _permissoes = [1, 4, 7, 14, 20];
                break;
            case "bm":
                _permissoes = [1, 4, 8, 14, 20];
                break;

            default:
                _permissoes = [1];
                break;
        }

        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const foundContent = roles.some(r => _permissoes.indexOf(r) >= 0);
        const foundStatistic = roles.some(r => [24].indexOf(r) >= 0);

        if (!foundContent && !foundStatistic) this.props.history.push({ pathname: '/permissao-negada' })
        else {
            this.setState({ bsMais: this.props.match.params.periodico === "bm", permissaoEdicao: foundContent }, () => {
                this.defineNomePeriodico();
            })
        }
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.location.pathname !== this.props.location.pathname) && this.props.location.pathname === "/conteudo/bm/artigos") {
            this.setState({
                bsMais: true
            }, () => {
                this.defineNomePeriodico();
                this.carregaArtigos();
            })
        }
    }
    defineNomePeriodico() {
        let _nomePer, _idProd;
        switch (this.props.match.params.periodico) {
            case "bs": _nomePer = "Brasil Seikyo"; _idProd = 1; break;
            case "bj": _nomePer = "Brasil Seikyo Japonês"; _idProd = 2; break;
            case "tc": _nomePer = "Terceira Civilização"; _idProd = 3; break;
            case "rd": _nomePer = "Revista Dez"; _idProd = 4; break;
            case "bm": _nomePer = "BS+ App"; _idProd = 5; break;
            default: _nomePer = ""; _idProd = 0; break;
        }
        this.setState(({ nomePeriodico: _nomePer, idProduto: _idProd }))
    }

    editarConteudo(_artigo) {
        this.props.history.push(`${this.props.match.url}/${_artigo.idConteudo}`)
    }

    novoArtigo() {
        this.props.history.push(`${this.props.match.url}/novo-artigo`)
    }

    toggleModal() {
        if (this.state.openModal) this.resetModalInfos();
        this.setState({ openModal: !this.state.openModal })
    }

    toggleStatusPublicacao() {
        this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })
    }

    onSelectFile(e) {
        this.setState({ fileUpload: e.target.files[0] })
    };

    onSelectFileCoverPageEdition(o) {
        this.setState({ fileUploadCapaEdicao: o.target.files[0] })
    };

    uploadArquivo() {
        this.setState({ isLoadingUpload: true })
        const { numEdicao, periodico } = this.props.match.params,
            formData = new FormData();
        // if (this.props.match.params.periodico === "bj") {
        //     formData.append("extra", "ftp");
        //     formData.append("nomeArqFTP", "bsj");
        // }
        formData.append("fileUpload", this.state.fileUpload);

        axios.post(this.Configurations.apiBasePath + `/conteudo/edicoes/${periodico}/${numEdicao}/upload`, formData, {
            headers: {
                "Content-Type": `multipart/form-data`,
            }
        }).then(response => {
            this.setState({
                arquivoEdicao: response.data.urlPublica,
                sucessoUpload: true,
                sucessoDelete: false,
                exibeUpload: false,
                fileUpload: undefined
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingUpload: false }));
    }

    uploadArquivoCapaEdicao() {
        this.setState({ isLoadingUploadCapaEdicao: true })
        const { numEdicao, periodico } = this.props.match.params,
            formData = new FormData();

        formData.append("imagem", this.state.fileUploadCapaEdicao);
        axios.post(this.Configurations.apiBasePath + `/imagem-de-capa/${periodico}/${numEdicao}`, formData, {
            headers: {
                "Content-Type": `multipart/form-data`,
            }
        }).then(response => {
            this.setState({
                capaEdicao: response.data.imagem.imagem,
                sucessoUploadCapaEdicao: true,
                sucessoDeleteCapaEdicao: false,
                exibeUploadCapaEdicao: true,
                fileUploadCapaEdicao: undefined
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingUploadCapaEdicao: false }));
    }



    removerArquivo() {
        this.setState({ isLoadingDelete: true })
        const { numEdicao, periodico } = this.props.match.params;
        // _filename = this.state.arquivoEdicao.split("https://storage.googleapis.com/edicoes-periodicos/")[1];
        axios.post(this.Configurations.apiBasePath + `/conteudo/edicoes/${periodico}/${numEdicao}/excluir`).then(response => {
            this.setState({
                sucessoUpload: false,
                sucessoDelete: true,
                exibeUpload: false,
                fileUpload: undefined,
                arquivoEdicao: response.data.arquivo,
                modalRemoverArquivo: false,
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingDelete: false }));
    }

    removerArquivoCapaEdicao() {
        this.setState({ isLoadingDeleteCapaEdicao: true })
        // const { numEdicao, periodico } = this.props.match.params;
        // _filename = this.state.arquivoEdicao.split("https://storage.googleapis.com/edicoes-periodicos/")[1];
        // axios.post(this.Configurations.apiBasePath + `/conteudo/edicoes/${periodico}/${numEdicao}/excluir`).then(response => {
        this.setState({
            sucessoUploadCapaEdicao: false,
            sucessoDeleteCapaEdicao: true,
            exibeUploadCapaEdicao: false,
            fileUploadCapaEdicao: undefined,
            capaEdicao: undefined,
            modalRemoverArquivoCapaEdicao: false,
        })
        // }).catch(this.handleError).finally(() => 
        this.setState({ isLoadingDeleteCapaEdicao: false })
        // );
    }



    toggleRemoverArquivo() {
        this.setState({ modalRemoverArquivo: !this.state.modalRemoverArquivo })
    }

    toggleRemoverArquivoCapaEdicao() {
        this.setState({ modalRemoverArquivoCapaEdicao: !this.state.modalRemoverArquivoCapaEdicao })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }


    refreshTableArticles(o) {
        this.carregaArtigos(o);
    }


    handleSelectStatusAprovacao(e, _name) {
        this.setState({ [_name]: { value: e.value, label: e.label }, msgSucessoStatusAprovacao: false })
    }

    salvarStatusAprovacao() {
        this.setState({ isLoadingStatusAprovacao: true })

        const periodico = this.props.match.params.periodico,
            numEdicao = this.state.numEdicao,
            status = this.state.opcaoStatusAprovacao.value;

        axios.post(this.Configurations.apiBasePath + `/conteudo/edicoes/aprovacao/${periodico}/${numEdicao}/${status}`).then(response => {
            this.setState({
                msgSucessoStatusAprovacao: true,
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingStatusAprovacao: false }));

    }
    carregaArtigos() {
        this.setState({ isLoadingArtigos: true })
        const isBsPlus = this.props.match.params.periodico.toUpperCase() === 'BM';
        const values = qs.parse(window.location.search),
            limite = parseInt(values.limite, 10),
            pagina = parseInt(values["?pagina"], 10);
        const rotaApi = this.state.semEdicao ? `/conteudo/edicoes/${this.props.match.params.periodico.toUpperCase()}/artigos-sem-edicao` : `/conteudo/edicoes/${this.props.match.params.periodico.toUpperCase()}/artigos/${isBsPlus ? '1' : `${this.props.match.params.numEdicao}`}?limite=${limite}&pagina=${pagina}`
        axios.get(this.Configurations.apiBasePath + rotaApi)
            .then(response => {
                const _artigos = response.data.artigos,
                    _edicao = response.data.edicao;
                this.setState({
                    listaArtigos: _artigos,
                    numEdicao: _edicao ? _edicao.numeroEdicao : undefined,
                    dtEdicao: _edicao ? _edicao.dtPublicacao : undefined,
                    statusEdicao: _edicao ? _edicao.status : undefined,
                    arquivoEdicao: _edicao ? _edicao.arquivo : undefined,
                    capaEdicao: _edicao ? _edicao.imagem : undefined,
                    paginasArtigosEdicoes: response.data.paginacao.totalPaginas,
                    idAprovacaoInicial: _edicao ? _edicao.idAprovacao : undefined,
                    limite: limite,
                    pagina: pagina,
                    arquivosAdicionais: _edicao.arquivosAdicionais
                })
            })
            .catch(this.handleError)
            .finally(() => { this.setState({ isLoadingArtigos: false }) })

    }

    onChangePage(page) {
        const { numEdicao, periodico } = this.props.match.params;
        this.setState({
            pagina: page,
        }, () => {
            this.props.history.push({ pathname: `/conteudo/${periodico.toLowerCase()}/${numEdicao}`, search: `?pagina=${this.state.pagina}&limite=${this.state.limite}` })
        });
    }

    toggleModalPdfsAdcionais() {
        this.setState({
            modalPdfsAdicionais: !this.state.modalPdfsAdicionais
        })
    }

    render() {
        return (
            <div className="row edition-details">
                <div className={`col-12`}>
                    {this.state.isLoadingArtigos ? (
                        <div className="row no-gutters">
                            <div className="col-12 text-center py-5">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        </div>
                    ) : (
                        <div className="row no-gutters">
                            <div className="col-12">
                                <div className="row no-gutters align-items-center">
                                    <div className="col-12 col-lg-8 text-center text-lg-left">
                                        {this.state.bsMais ? (
                                            <React.Fragment>
                                                <h2 className="title-1 d-none d-lg-block">Lista de artigos - {this.state.nomePeriodico}</h2>
                                                <h5 className="d-lg-none">{this.state.nomePeriodico} - Lista de artigos</h5>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                <h2 className="title-1 d-none d-lg-block"> {this.state.nomePeriodico} - {this.state.semEdicao ? 'Artigos sem edição' : `Edição ${this.state.numEdicao} (${moment(this.state.dtEdicao).format("DD/MM/YY")})`}</h2>
                                                <h5 className="d-lg-none d-none">{this.state.nomePeriodico}</h5>
                                                <h5 className="title-1 d-lg-none"> {this.props.match.params.periodico.toUpperCase()} - {this.state.semEdicao ? 'Sem edição' : `Edição ${this.state.numEdicao} (${moment(this.state.dtEdicao).format("DD/MM/YY")})`} </h5>
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div className="col-12 col-lg-4 text-center text-lg-right">
                                        <div className="row no-gutters">
                                            <div className="col py-2 py-lg-0">
                                                <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row no-gutters">
                                    <div id="artigos" className="col-12">
                                        <div className="card">
                                            <div className="card-body px-0">
                                                <div className="row no-gutters align-items-center pb-lg-3 px-lg-3">
                                                    <div className="col-12 col-lg-4 py-lg-0 text-center text-lg-left">
                                                        {(!this.state.bsMais && !this.state.semEdicao) && (
                                                            <h6 className="m-0">Status: <span className={`badge badge-${this.state.statusEdicao === "Publicada" ? 'success' : 'secondary badge-opacity'}`}>{this.state.statusEdicao}</span></h6>
                                                        )}
                                                    </div>
                                                    {/* Layout desktop */}
                                                    <div className="col-lg-4 d-lg-block d-none">
                                                        {(!this.state.bsMais && !this.state.semEdicao) && (
                                                            <div className="row no-gutters">
                                                                {this.state.statusEdicao === "Publicada" ? (
                                                                    <div className="col-12 py-3 py-lg-0 text-center">
                                                                        {this.state.permissaoEdicao && (
                                                                            <button onClick={() => this.confirmaStatusPublicacao(this.state.numEdicao, "desativar")} className="btn btn-outline-danger">desativar edição</button>
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <div className="col-12 py-3 py-lg-0 text-center">
                                                                        {this.state.permissaoEdicao && (
                                                                            <button onClick={() => this.confirmaStatusPublicacao(this.state.numEdicao, "publicar")} className="btn btn-outline-info">publicar edição</button>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-lg-4 pb-3 py-lg-2 text-right d-lg-block d-none">
                                                        {(this.props.match.params.periodico !== "bj" && this.state.permissaoEdicao) && (
                                                            <button onClick={this.novoArtigo} className="btn btn-outline-success">novo artigo</button>
                                                        )}
                                                    </div>


                                                    {/* Layout mobile */}
                                                    <div className={`col-12 py-2 text-center d-lg-none`}>
                                                        <div className="row no-gutters d-lg-none">
                                                            {(!this.state.bsMais && !this.state.semEdicao) && (
                                                                <div className={`${this.props.match.params.periodico === "bj" ? "col-12" : "col-6"} py-2 text-center d-lg-none`}>
                                                                    <div className="row no-gutters d-lg-none">
                                                                        <React.Fragment>
                                                                            {this.state.statusEdicao === "Publicada" ? (
                                                                                <div className="col-12 py-3 py-lg-0 text-center px-3 d-lg-none">
                                                                                    {this.state.permissaoEdicao && (
                                                                                        <button onClick={() => this.confirmaStatusPublicacao(this.state.numEdicao, "desativar")} className="btn btn-outline-danger">desativar</button>
                                                                                    )}
                                                                                </div>
                                                                            ) : (
                                                                                <div className="col-12 py-3 py-lg-0 text-center px-3 d-lg-none">
                                                                                    {this.state.permissaoEdicao && (
                                                                                        <button onClick={() => this.confirmaStatusPublicacao(this.state.numEdicao, "publicar")} className="btn btn-outline-info">publicar</button>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </React.Fragment>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {(this.props.match.params.periodico !== "bj" && this.state.permissaoEdicao) && (
                                                                <div className={`${(this.state.bsMais || this.state.semEdicao) ? "col-12" : "col-6"} py-lg-2 py-2 text-center d-lg-none`}>
                                                                    <div className='row no-gutters d-lg-none'>
                                                                        <div className='col-12 py-3 py-lg-0 text-center px-3 d-lg-none'>
                                                                            {true && (
                                                                                <button onClick={this.novoArtigo} className="btn btn-outline-success">novo artigo</button>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {(!this.state.bsMais && !this.state.semEdicao) && (
                                                    <div className="row no-gutters align-items-center pb-lg-3">
                                                        <div className="col-12 col-lg-6 text-center text-lg-left pt-3 pb-2 px-lg-3">
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="row align-items-end">
                                                                        {/* Layout desktop */}
                                                                        {this.state.permissaoEdicao && (
                                                                            <React.Fragment>
                                                                                {(this.props.match.params.periodico === "rd" || this.props.match.params.periodico === "bs" || this.props.match.params.periodico === "tc" ) && (
                                                                                    <div className="col-lg-12 my-0 d-none d-lg-block py-2">
                                                                                        <button className='btn btn-outline-primary' onClick={this.toggleModalPdfsAdcionais}>PDFs adicionais</button>
                                                                                    </div>
                                                                                )}
                                                                                {this.props.match.params.periodico !== "rd" && (
                                                                                    <div className="col-lg-12 my-0 d-none d-lg-block">
                                                                                        <span>PDF da Edição:</span>
                                                                                        {this.state.arquivoEdicao ? (
                                                                                            <>
                                                                                                <a target="_blank" rel="noopener noreferrer" href={this.state.arquivoEdicao}><i className="far fa-file-pdf ml-2 mr-1 text-primary"></i><span className="text-primary">visualizar PDF</span></a>
                                                                                                {this.state.isLoadingDelete ? (
                                                                                                    <div className="spinner-border text-primary" role="status" />
                                                                                                ) : (
                                                                                                    <span onClick={this.toggleRemoverArquivo} className="cursor-pointer">
                                                                                                        <i className={'far fa-trash-alt ml-3 mr-1 text-danger'}></i><span className="text-danger">remover</span>
                                                                                                    </span>
                                                                                                )}
                                                                                            </>
                                                                                        ) : (
                                                                                            <span className="cursor-pointer">
                                                                                                <i className={'far fa-file-alt ml-3 mr-1 text-success'}></i><span className="text-success" onClick={() => this.setState({ exibeUpload: true, sucessoUpload: false, sucessoDelete: false })}>novo arquivo</span></span>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </React.Fragment>
                                                                        )}

                                                                        {this.state.exibeUpload && (
                                                                            <div className="col-12 col-lg-12 text-center text-lg-left py-2 px-3 d-align-items-center d-lg-block d-none">
                                                                                <div className="row py-3">
                                                                                    <div className="col-12">
                                                                                        <input type="file" accept=".pdf" className="input-arquivo b" onChange={this.onSelectFile} />
                                                                                        {this.state.isLoadingUpload ? (
                                                                                            <div className="spinner-border text-primary" role="status" />
                                                                                        ) : (
                                                                                            <button disabled={!this.state.fileUpload} className="btn btn-outline-success mx-2" onClick={this.uploadArquivo}>upload PDF</button>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className="col-12">
                                                                                        <div className="row">
                                                                                            {this.state.sucessoUpload && (
                                                                                                <div className="col-12 text-lg-left py-2 d-lg-block d-none">
                                                                                                    <p className="text-success mb-0"><i>Upload de PDF realizado com sucesso!</i></p>
                                                                                                </div>
                                                                                            )}
                                                                                            {this.state.sucessoDelete && (
                                                                                                <div className="col-12 text-lg-left py-2 d-lg-block d-none">
                                                                                                    <p className="text-danger mb-0"><i>PDF removido com sucesso!</i></p>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/* Layout mobile */}
                                                                        {this.state.permissaoEdicao && (
                                                                            <React.Fragment>
                                                                                {(this.props.match.params.periodico === "rd" || this.props.match.params.periodico === "bs") && (
                                                                                    <div className="col-12 my-0 d-lg-none py-2">
                                                                                        <button className='btn btn-outline-primary' onClick={this.toggleModalPdfsAdcionais}>PDFs adicionais</button>
                                                                                    </div>
                                                                                )}
                                                                                {this.props.match.params.periodico !== "rd" && (
                                                                                    <div className="col-12 my-0 d-lg-none">
                                                                                        <span>PDF da Edição:</span>
                                                                                        {this.state.arquivoEdicao ? (
                                                                                            <>
                                                                                                <a target="_blank" rel="noopener noreferrer" href={this.state.arquivoEdicao}><i className="far fa-file-pdf ml-2 mr-1 text-primary"></i><span className="text-primary">visualizar PDF</span></a>
                                                                                                {this.state.isLoadingDelete ? (
                                                                                                    <div className="spinner-border text-primary" role="status" />
                                                                                                ) : (
                                                                                                    <span onClick={this.toggleRemoverArquivo} className="cursor-pointer">
                                                                                                        <i className={'far fa-trash-alt ml-3 mr-1 text-danger'}></i><span className="text-danger">remover</span>
                                                                                                    </span>
                                                                                                )}
                                                                                            </>
                                                                                        ) : (
                                                                                            <span className="cursor-pointer">
                                                                                                <i className={'far fa-file-alt ml-3 mr-1 text-success'}></i><span className="text-success" onClick={() => this.setState({ exibeUpload: true, sucessoUpload: false, sucessoDelete: false })}>novo arquivo</span></span>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                                {this.state.exibeUpload && (
                                                                                    <div className="row">
                                                                                        <div className="col-12 col-lg-12 text-center py-2 d-align-items-center d-lg-none">
                                                                                            <input type="file" accept=".pdf" className="input-arquivo b w-100" onChange={this.onSelectFile} />
                                                                                            {this.state.isLoadingUpload ? (
                                                                                                <div className="spinner-border text-primary mt-3" role="status" />
                                                                                            ) : (
                                                                                                <button disabled={!this.state.fileUpload} className="btn btn-outline-success mx-2 mt-3" onClick={this.uploadArquivo}>upload PDF</button>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                                {this.state.sucessoUpload && (
                                                                                    <div className="col-12 text-center py-2 ">
                                                                                        <p className="text-success mb-0"><i>Upload de PDF realizado com sucesso!</i></p>
                                                                                    </div>
                                                                                )}
                                                                                {this.state.sucessoDelete && (
                                                                                    <div className="col-12 text-center py-2">
                                                                                        <p className="text-danger mb-0"><i>PDF removido com sucesso!</i></p>
                                                                                    </div>
                                                                                )}
                                                                            </React.Fragment>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6">
                                                            <div className="row">
                                                                {/*Layout desktop*/}
                                                                {this.state.permissaoEdicao && (
                                                                    <div className="col-lg-12 text-lg-left d-none d-lg-block">
                                                                        <span>Capa da edição: </span>
                                                                        {!!this.state.capaEdicao ? (
                                                                            <>
                                                                                <a target="_blank" rel="noopener noreferrer" href={`${this.state.capaEdicao}?v=${Math.random()}`}><i className="fas fa-file-image ml-2 mr-1 text-primary"></i><span className="text-primary">visualizar capa</span></a>
                                                                                {this.state.isLoadingDeleteCapaEdicao ? (
                                                                                    <div className="spinner-border text-primary ml-3" role="status" />
                                                                                ) : (
                                                                                    <span onClick={this.toggleRemoverArquivoCapaEdicao} className="cursor-pointer">
                                                                                        <i className={'far fa-trash-alt ml-3 mr-1 text-danger'}></i><span className="text-danger">remover</span>
                                                                                    </span>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <span className="cursor-pointer">
                                                                                <i className={'fas fa-file-image ml-3 mr-1 text-success'}></i><span className="text-success" onClick={() => this.setState({ exibeUploadCapaEdicao: true, sucessoUploadCapaEdicao: false, sucessoDeleteCapaEdicao: false })}>novo arquivo</span></span>
                                                                        )}
                                                                    </div>

                                                                )}

                                                                {this.state.exibeUploadCapaEdicao && (
                                                                    <div className="col-12 col-lg-12 text-center text-lg-left py-2 d-align-items-center d-lg-block d-none">
                                                                        <div className="row">
                                                                            <div className="col-12">
                                                                                <input type="file" accept=".jpg,.jpeg,.png" className="input-capa-edicao" onChange={this.onSelectFileCoverPageEdition} />
                                                                                {this.state.isLoadingUploadCapaEdicao ? (
                                                                                    <div className="spinner-border text-primary" role="status" />
                                                                                ) : (
                                                                                    <button disabled={!this.state.fileUploadCapaEdicao} className="btn btn-outline-success mx-2" onClick={this.uploadArquivoCapaEdicao}>upload capa</button>
                                                                                )}
                                                                            </div>
                                                                            <div className="col-12">
                                                                                <div className="row">
                                                                                    {this.state.sucessoUploadCapaEdicao && (
                                                                                        <div className="col-12 text-lg-left py-2 d-lg-block d-none">
                                                                                            <p className="text-success mb-0"><i>Upload de capa de edição realizado com sucesso!</i></p>
                                                                                        </div>
                                                                                    )}
                                                                                    {this.state.sucessoDeleteCapaEdicao && (
                                                                                        <div className="col-12 text-lg-left py-2 d-lg-block d-none">
                                                                                            <p className="text-danger mb-0"><i>Capa de edição removido com sucesso!</i></p>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="col-12 col-lg-12">
                                                            <div className="row">
                                                                <div className="col-12 col-lg-6">
                                                                    <DivPermission
                                                                        arrayPerm={[1, 22]}
                                                                        permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                                                    >

                                                                        {this.props.match.params.periodico !== "bj" && (
                                                                            <div className="row align-items-end no-gutters">
                                                                                <div className="col-12 col-lg-7 mt-3 px-3">
                                                                                    <div className="form-group m-0">
                                                                                        <label htmlFor="statusAprovacao">Status aprovação: </label>
                                                                                        <Select
                                                                                            id="statusAprovacao"
                                                                                            placeholder="Selecione um status"
                                                                                            closeMenuOnSelect={true}
                                                                                            components={makeAnimated()}
                                                                                            options={this.opcoesStatusAprovacao.filter(item => item.periodicos.some(i => i === this.props.match.params.periodico))}
                                                                                            onChange={(e) => this.handleSelectStatusAprovacao(e, "opcaoStatusAprovacao")}
                                                                                            name="opcaoStatusAprovacao"
                                                                                            defaultValue={this.opcoesStatusAprovacao.filter(item => item.value === this.state.idAprovacaoInicial)}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-12 col-lg-5 mt-3 mb-3 mb-lg-1 mt-lg-0 text-center">
                                                                                    {this.state.isLoadingStatusAprovacao ? (
                                                                                        <div className="spinner-border text-primary" role="status" />
                                                                                    ) : (
                                                                                        <button onClick={this.salvarStatusAprovacao} disabled={!!!this.state.opcaoStatusAprovacao} className="btn btn-outline-success">Salvar</button>
                                                                                    )}
                                                                                </div>
                                                                                {this.state.msgSucessoStatusAprovacao && (
                                                                                    <div className="col-lg-7 text-center d-lg-block d-none">
                                                                                        <p className="text-success mb-0"><i>Alteração realizada com sucesso!</i></p>
                                                                                    </div>
                                                                                )}
                                                                                {this.state.msgSucessoStatusAprovacao && (
                                                                                    <div className="col-12 text-center d-lg-none">
                                                                                        <p className="text-success mb-0"><i>Alteração realizada com sucesso!</i></p>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        )}

                                                                    </DivPermission>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {/*Layout mobile*/}
                                                {this.state.permissaoEdicao && this.props.match.params.periodico !== "bm" && (
                                                    <div className="col-12 d-lg-none my-3 text-center">
                                                        <span>Capa da edição: </span>
                                                        {!!this.state.capaEdicao ? (
                                                            <>
                                                                <div className="row no-gutters mt-2">
                                                                    <div className="col-7 text-left px-2">
                                                                        <a target="_blank" rel="noopener noreferrer" href={`${this.state.capaEdicao}?v=${Math.random()}`}><i className="fas fa-file-image ml-2 mr-1 text-primary"></i><span className="text-primary">visualizar capa</span></a>
                                                                    </div>
                                                                    {this.state.isLoadingDeleteCapaEdicao ? (
                                                                        <div className="spinner-border text-primary ml-3" role="status" />
                                                                    ) : (
                                                                        <div className="col-5 text-right pr-3">
                                                                            <span onClick={this.toggleRemoverArquivoCapaEdicao} className="cursor-pointer">
                                                                                <i className={'far fa-trash-alt ml-3 mr-1 text-danger'}></i><span className="text-danger">remover</span>
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <span className="cursor-pointer">
                                                                <i className={'fas fa-file-image ml-3 mr-1 text-success'}></i><span className="text-success" onClick={() => this.setState({ exibeUploadCapaEdicao: true, sucessoUploadCapaEdicao: false, sucessoDeleteCapaEdicao: false })}>novo arquivo</span>
                                                            </span>
                                                        )}
                                                    </div>

                                                )}
                                                {this.state.exibeUploadCapaEdicao && (
                                                    <div className="col-12 text-center py-2 d-align-items-center d-lg-none">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <input type="file" accept=".jpg,.jpeg,.png" className="input-capa-edicao w-100" onChange={this.onSelectFileCoverPageEdition} />
                                                                {this.state.isLoadingUploadCapaEdicao ? (
                                                                    <div className="spinner-border text-primary" role="status" />
                                                                ) : (
                                                                    <button disabled={!this.state.fileUploadCapaEdicao} className="btn btn-outline-success mx-2 mt-3" onClick={this.uploadArquivoCapaEdicao}>upload capa</button>
                                                                )}
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="row">
                                                                    {this.state.sucessoUploadCapaEdicao && (
                                                                        <div className="col-12 text-center py-2">
                                                                            <p className="text-success mb-0"><i>Upload de capa de edição realizado com sucesso!</i></p>
                                                                        </div>
                                                                    )}
                                                                    {this.state.sucessoDeleteCapaEdicao && (
                                                                        <div className="col-12 text-center py-2">
                                                                            <p className="text-danger mb-0"><i>Capa de edição removido com sucesso!</i></p>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}


                                                {this.state.isLoadingArtigos ? (
                                                    <div className="col-12 text-center px-3 py-5">
                                                        <div className="spinner-border text-primary" role="status" />
                                                    </div>
                                                ) : (
                                                    <div className="col-12">
                                                        <div className="row lista-artigos">
                                                            {this.state.listaArtigos.map((item, index) => {
                                                                return (
                                                                    <div className="col-12 py-2" key={index}>
                                                                        <Articles
                                                                            item={item}
                                                                            mudaStatusArtigo={this.mudaStatusArtigo}
                                                                            history={this.props.history}
                                                                            match={this.props.match}
                                                                            permissaoEdicao={this.state.permissaoEdicao}
                                                                        />
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {this.state.listaArtigos.length <= 0 && (
                                            <div className="col-12 text-center py-5">
                                                <h3>Não há artigos cadastrados</h3>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {!this.state.isLoadingArtigos && this.state.listaArtigos && this.state.listaArtigos.length > 0 && (
                        <div className="col-12 mt-2 px-0">
                            <div className="paginacao-artigos">
                                <Pagination onChange={this.onChangePage} current={this.state.pagina} total={this.state.paginasArtigosEdicoes * this.state.limite} pageSize={this.state.limite} />
                            </div>
                        </div>
                    )}
                </div>

                <Modal isOpen={this.state.modalStatusPublicacao} toggle={this.toggleStatusPublicacao}>
                    <ModalHeader toggle={this.toggleStatusPublicacao}>Mudança de Status da Edição</ModalHeader>
                    <ModalBody>
                        {this.state.metodoStatusPublicacao === 'publicar' ? (
                            <p className="m-0">{`Deseja confirmar a publicação da Edição ${this.state.numEdicaoStatusPublicacao}?`}</p>
                        ) : (
                            <p className="m-0">{`Deseja desativar a Edição ${this.state.numEdicaoStatusPublicacao}?`}</p>
                        )}

                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingStatusEdicao ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingStatusEdicao} color={`${this.state.metodoStatusPublicacao === 'publicar' ? `success` : `danger`}`} onClick={this.mudaStatusEdicao}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })}>voltar</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalRemoverArquivo} toggle={this.toggleRemoverArquivo}>
                    <ModalHeader toggle={this.toggleRemoverArquivo}>Remover PDF da Edição</ModalHeader>
                    <ModalBody>
                        <p className="m-0">{`Deseja remover o PDF da Edição ${this.state.numEdicao}?`}</p>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingDelete ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingDelete} color={`danger`} onClick={this.removerArquivo}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalRemoverArquivo: !this.state.modalRemoverArquivo })}>voltar</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalRemoverArquivoCapaEdicao} toggle={this.toggleRemoverArquivoCapaEdicao}>
                    <ModalHeader toggle={this.toggleRemoverArquivoCapaEdicao}>Remover capa da edição</ModalHeader>
                    <ModalBody>
                        <p className="m-0">{`Deseja remover a capa da edição ${this.state.numEdicao}?`}</p>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingDeleteCapaEdicao ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingDeleteCapaEdicao} color={`danger`} onClick={this.removerArquivoCapaEdicao}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalRemoverArquivoCapaEdicao: !this.state.modalRemoverArquivoCapaEdicao })}>voltar</Button>
                    </ModalFooter>
                </Modal>
                <ModalPdfsAdicionais
                    toggle={this.toggleModalPdfsAdcionais}
                    isOpen={this.state.modalPdfsAdicionais}
                    onSelectFile={this.onSelectFile}
                    fileUpload={this.state.fileUpload}
                    arquivosAdicionais={this.state.arquivosAdicionais}
                    numEdicao={this.props.match.params.numEdicao}
                    periodico={this.props.match.params.periodico}
                    carregaArtigos={this.carregaArtigos}
                    isLoadingArtigos={this.state.isLoadingArtigos}
                    atualizaLista={(lista) => this.setState({ arquivosAdicionais: lista })}
                />

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={!this.state.hasError}
                />
            </div >
        )
    }
}

export default EditionDetails;
